import React, {useRef} from 'react'
import styles from './entranceScreen.module.css'
import {useTranslation} from 'react-i18next'
import {Button, message, Space} from 'antd'
import {postEntrance} from '../../../api/shippingApi'
import {showApiError, showMessage, showMessageWithTitle} from '../../../common/message'
import {entryPasswordRegex} from '../../../common/regex'
import EntranceForm from '../../organism/entrance/EntranceForm'
import {EEntranceOption} from '../tracking/type'
import {useNavigate, useParams} from "react-router-dom";

/**
 * 공동현관 비밀번호를 수령정보랑 다른 entity입니다. 공동현관은 이전 데이터를 보여 주지 않는다. by kokospapa
 * @param tracking
 * @param onEntrySaved
 * @constructor
 */
export const EntranceInfoScreen = () => {
    const {t} = useTranslation(['location'])
    const entranceCodeRef = useRef('')
    const entranceRef = useRef<EEntranceOption>()
    const navigate = useNavigate();

    const [messageApi, messageHolder] = message.useMessage();
    const {tracking} = useParams();

    const handleChangeEntrance = (value: EEntranceOption) => {
        entranceRef.current = value
    }
    const handleChangeEntranceCode = (value: string) => {
        entranceCodeRef.current = value
    }

    const handleSaveResult = () => {
        if (entranceRef.current === EEntranceOption.GATECODE) {
            //공동현관 비밀번호 선택시
            if (!entranceCodeRef.current) {
                showMessage(messageApi, t('popup.error.entry.code.empty'))
                return
            } else if (!!entranceCodeRef.current && entryPasswordRegex.test(entranceCodeRef.current)) {
                showMessage(messageApi, t('popup.error.code.invalid'))
                return
            }
        }
        if (tracking)
            postEntrance(
                tracking,
                {
                    entrance_option: entranceRef.current,
                    information: entranceCodeRef.current,
                },
            ).then(res => {
                console.log('postDeliveryComplete', res);
                showMessageWithTitle(
                    t('popup.success.location.content'),
                )
                navigate('/tracking/'+tracking);
            })
                .catch(error => showApiError(error, messageApi))
    }

    return (
        <Space direction={'vertical'} size={20}>
            {messageHolder}
            <div className={'round-cntr info-container'}>
                <div className={'h2'}>{t('entrance.large.label')}</div>
                <div className={'body black45 preline ' + styles.label}>{t('entrance.label')}</div>
            </div>
            <EntranceForm onEntrancePasswordChange={handleChangeEntranceCode}
                          onEntranceOptionChange={handleChangeEntrance}/>
            <div className={"floating-btn-margin"}/>
            <Button type={'primary'} size={"large"} className={"floating-btn"} data-cy={'saveResult'}
                    onClick={handleSaveResult}>
                {t('complete')}
            </Button>
        </Space>
    )
}